/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Configurator_Page_Meta_DescriptionInputs */

const de_configurator_page_meta_description = /** @type {(inputs: Configurator_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen Sie Ihr waipu.tv-Paket zusammen: Basispaket wählen, Optionen hinzufügen und den Preis im Blick behalten.`)
};

/** @type {(inputs: Configurator_Page_Meta_DescriptionInputs) => LocalizedString} */
const en_configurator_page_meta_description = de_configurator_page_meta_description;

/**

* @param {Configurator_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const configurator_page_meta_description = /** @type {((inputs?: Configurator_Page_Meta_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Configurator_Page_Meta_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_configurator_page_meta_description(inputs)
	return en_configurator_page_meta_description(inputs)
});